export default __webpack_public_path__ + "static/bg-wires-f6e6c4fbcb33ae2c10ff190e9a677da8.jpg";